const DEFAULTS = {
  containerEl: document.querySelector('[data-video-strip]'),
  
  scrollerSelector: '[data-video-strip-scroller]',
  leftButtonSelector: '[data-video-strip-control="left"]',
  rightButtonSelector: '[data-video-strip-control="right"]',
  visibleBtnClass: 'video-playlist__scroll-btn--visible',
  slideItemSelector: '[data-video-strip-item]',

  scrollWidth: '[data-video-strip-item]',
  firstItem: '[data-video-strip-item]:first-of-type',
  lastItem: '[data-video-strip-item]:last-of-type',

  scrollFactor: 3,

};

export default class slideScroller {
  constructor(containerEl, options = DEFAULTS) {
    this.options = {...DEFAULTS, ...options};

    this.scrollerEl = containerEl.querySelector(this.options.scrollerSelector);

    this.leftButton = containerEl.querySelector(this.options.leftButtonSelector);
    this.rightButton = containerEl.querySelector(this.options.rightButtonSelector);
    this.visibleBtnClass = this.options.visibleBtnClass;

    this.scrollWidth = containerEl.querySelector(this.options.slideItemSelector).scrollWidth;
    this.firstItem = containerEl.querySelector(`${this.options.slideItemSelector}:first-of-type`);
    this.lastItem = containerEl.querySelector(`${this.options.slideItemSelector}:last-of-type`);

    this.firstItem.dataset.videoStripItem = 'first';
    this.lastItem.dataset.videoStripItem = 'last';

    this.scrollFactor = this.options.scrollFactor;

    this.events();
    this.observers();

  }

  events() {
    this.rightButton.addEventListener('click', this._scrollSlides.bind(this));
    this.leftButton.addEventListener('click', this._scrollSlides.bind(this));
  }

  observers() {
    this.slideObserver = this._createSlideObserver();
    this.slideObserver.observe(this.firstItem);
    this.slideObserver.observe(this.lastItem);
  }

  _scrollSlides({ target }) {
    const direction = target.dataset.videoStripControl === 'left' ? -1 : 1;
    const scrollTotal = direction * this.scrollWidth * this.scrollFactor;
    this.scrollerEl.scrollLeft += scrollTotal;
  }

  _createSlideObserver() {
    return new IntersectionObserver(changes => {
      changes.forEach( ({ intersectionRatio, target }) => {
        if (intersectionRatio === 1) {
          if (target.dataset.videoStripItem === 'first') {
            this.leftButton.classList.remove(this.visibleBtnClass);
          } else if (target.dataset.videoStripItem === 'last') {
            this.rightButton.classList.remove(this.visibleBtnClass);
          }
        } else {
          this.leftButton.classList.add(this.visibleBtnClass);
          this.rightButton.classList.add(this.visibleBtnClass);
        }
      });
    }, {
      root: this.playlistScroller,
      threshold: [0, 1],
    });
  }
}
